<script>
export default {
  name: "UserSelect",
  data() {
    return {
      selected: null,
      search: "",
      focused: false,
      page: 1,
      isLoadingMore: false,
      hasMore: true,
    }
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: ""
    },
    options: [],
    onLoadMore: {
      type: Function,
      required: false,
      default: null
    }
  },
  methods: {
    async handleScroll(event) {
      const element = event.target
      const bottom = element.scrollHeight - element.scrollTop === element.clientHeight
      if (bottom && !this.isLoadingMore && this.hasMore && this.onLoadMore) {
        this.isLoadingMore = true
        this.page++
        try {
          const hasMoreData = await this.onLoadMore(this.page, this.search)
          this.hasMore = hasMoreData
        } catch (e) {
          console.error('Error loading more:', e)
        } finally {
          this.isLoadingMore = false
        }
      }
    },
    handleSelect(option) {
      this.selected = option
      this.search = option.text
      this.focused = false
      this.$emit('select', option)
    },
    clear() {
      this.selected = null
      this.search = ""
      this.focused = false
      this.page = 1
      this.hasMore = true
      this.$emit('search', '')

    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.focused = false
      }
    }
  },
  computed: {
    filterOptions() {
      if (!this.search) return this.options
      return this.options.filter(option =>
          option.text.toLowerCase().includes(this.search.toLowerCase())
      )
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {
    search(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1
        this.hasMore = true
        this.$emit('search', newVal)
      }
    }
  }
}
</script>

<template>
  <div class="user-select p-relative">
    <b-form-input @focus="focused = true"
                  type="text"
                  v-model="search"
                  :placeholder="placeholder"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
    />
    <div v-if="focused" class="user-select-options" @scroll="handleScroll">
      <div @click="handleSelect(option)" v-for="option in filterOptions" :key="option.id" class="user-select-option">
        {{ option.text }}
      </div>
      <div v-if="isLoadingMore" class="user-select-loading">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Загрузка...</span>
        </div>
      </div>
      <div v-if="!hasMore && filterOptions.length > 0" class="user-select-end">
        Больше нет данных
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.user-select input {
  width: 100%;
  margin-top: 10px;
}

.user-select-options {
  position: absolute;
  background: white;
  width: 100%;
  z-index: 10;
  max-height: 200px;
  overflow-y: scroll;
}

.user-select-loading {
  padding: 10px;
  text-align: center;
  color: #6c757d;
}

.user-select-end {
  padding: 10px;
  text-align: center;
  color: #6c757d;
  font-size: 12px;
}

.user-select-option {
  padding: 10px;
  cursor: pointer;
}
</style>